import _isEqual from 'lodash/isEqual';
import { Tracking } from 'bdvp-tracking';

import FilterSelection from '../../models/FilterSelection';
import { FILTER_TYPE } from '../../utils/constants';

export const formatOptions = (values, reversedOptions = false) => {

    if (!Array.isArray(values)) {

        return [];

    }

    const formattedOptions = values
        .map(({
            displayValue: label,
            ...rest
        }) => ({
            label,
            ...rest,
        }));

    if (reversedOptions) {

        formattedOptions.reverse();

    }

    return formattedOptions;

};

export const normalizeFields = (filterConfig, fieldsData, activeFilters) => {

    return filterConfig.fields.map((field) => {

        const filterType = field.type ?? FILTER_TYPE.default;

        const selectedFilter = activeFilters.find(filter => (
            filter.type === filterType
            && filter.fieldId.toString() === field.id.toString()
        ));

        const selectedValues = selectedFilter
            ? selectedFilter.values
                .map(({ value, ...rest }) => ({
                    value: value.toString(),
                    ...rest,
                }))
            : [];

        const newField = {
            ...fieldsData.find(dataField => Number(dataField.id) === field.id),
            ...field.overrides,
        };

        newField.selected = selectedValues;
        newField.options = formatOptions(newField.values, field.reversedOptions);
        newField.filterType = filterType;

        return newField;

    });

};


export const filterOnChange = (data, field, addSelectedFilter, removeSelectedFilter) => {

    const {
        changes,
        selected,
        event,
    } = data;
    const changesValue = changes.value;
    const changesLabel = changes.label;
    const fieldName = field.name;
    const fieldType = field.type;
    const filterType = field.filterType;
    const fieldDisplayName = field.displayName;

    if (event.includes('deselect')) {

        Tracking.trackFilterAccordionItemDeselect(fieldDisplayName, changesLabel);
        const value = fieldType === "NUMBER" ? Number(changesValue) : changesValue;

        return removeSelectedFilter(fieldName, value);

    }

    const selectedItems = selected.map((f) => {

        const fValue = f.value;

        return {
            ...f,
            value: fieldType === "NUMBER" ? Number(fValue) : fValue,
        };

    });

    const filter = new FilterSelection({
        name: fieldName,
        type: filterType,
        id: field.id,
        fieldId: field.id,
        comparator: field.defaultOperator,
        displayName: fieldDisplayName,
    }, selectedItems);

    Tracking.trackFilterAccordionItemSelect(fieldDisplayName, changesLabel);

    return addSelectedFilter(filter);

};

export const shouldNotReRender = (prevProps, nextProps) => {

    if (
        prevProps.fieldsData !== nextProps.fieldsData
        || prevProps.filterConfig !== nextProps.filterConfig
    ) {

        return false;

    }

    const fields = nextProps.filterConfig.fields.map((field) => field.id);
    const inPrev = prevProps.activeFilters.filter(field => fields.includes(field.fieldId));
    const inNext = nextProps.activeFilters.filter(field => fields.includes(field.fieldId));

    if (inPrev.length <= 0 && inNext.length <= 0) {

        return true;

    }

    if (
        (inPrev.length <= 0 && inNext.length > 0)
        || (inPrev.length > 0 && inNext.length <= 0)
    ) {

        return false;

    }

    return _isEqual(inPrev, inNext);

};
